import { Injectable } from '@angular/core';
import { PromoDealsElement } from '@models/cms/cms-dynamic/dynamic-page.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PromoCodesService {

  private activePromoDeal$ = new BehaviorSubject<PromoDealsElement | null>(null);

  onChangeActivePromoDeal() {
    return this.activePromoDeal$.asObservable()
  }

  setActivePromoDeal(promo: PromoDealsElement) {
    this.activePromoDeal$.next(promo);
  }

  clearActivePromoDeal() {
    this.activePromoDeal$.next(null);
  }
}
